import { render, staticRenderFns } from "./xdr.vue?vue&type=template&id=7f0ffa5a&scoped=true&"
import script from "./xdr.vue?vue&type=script&lang=js&"
export * from "./xdr.vue?vue&type=script&lang=js&"
import style0 from "./xdr.vue?vue&type=style&index=0&id=7f0ffa5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0ffa5a",
  null
  
)

export default component.exports